import { useEffect, useId, useRef, useState } from "react";
import { Icon } from "../Icon";

// Disclosure dropdown of the header bar. `trigger` is what the button shows; `label` names the button
// when its content has no text (icon only). The panel holds `children` (buttons / links with the class
// "header_menu_item"): choosing one closes it. Escape and a click outside close it too.
const HeaderMenu = ({ className = "", label, trigger, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const triggerRef = useRef(null);
  const panelId = useId();

  useEffect(() => {
    if (!isOpen) return undefined;
    const closeOnOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutside);
    document.addEventListener("touchstart", closeOnOutside);
    return () => {
      document.removeEventListener("mousedown", closeOnOutside);
      document.removeEventListener("touchstart", closeOnOutside);
    };
  }, [isOpen]);

  const onKeyDown = (event) => {
    if (event.key === "Escape" && isOpen) {
      setIsOpen(false);
      triggerRef.current?.focus();
    }
  };

  return (
    <div className={`header_menu ${className}`.trim()} ref={wrapperRef} onKeyDown={onKeyDown}>
      <button
        type="button"
        className="header_menu_trigger"
        ref={triggerRef}
        aria-label={label}
        aria-expanded={isOpen}
        aria-controls={isOpen ? panelId : undefined}
        onClick={() => setIsOpen((open) => !open)}
      >
        {trigger}
        <Icon icon="fa-angle-down" className="header_menu_chevron" size="sm" aria-hidden="true" />
      </button>
      {isOpen && (
        <div
          id={panelId}
          className="header_menu_panel"
          onClick={(event) => {
            if (event.target.closest("a, button")) setIsOpen(false);
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default HeaderMenu;
